// extracted by mini-css-extract-plugin
export default {"accordion":"styles-module__accordion___nHbiB","button":"styles-module__button___PUnVo","panel":"styles-module__panel___B2ROF","icon":"styles-module__icon___Uo8kq"};